import api from 'service/api'

const trainingPortalAPI = api.create('trainingPortal', false)

const index = async (params = {}) =>
  trainingPortalAPI.get('/courses', { params })

const categories = async () => trainingPortalAPI.get('/courses/categories')

const indexByCategory = async (categoryId, params = {}) =>
  trainingPortalAPI.get(`/categories/${categoryId}/courses`, { params })

const show = async (courseId) => trainingPortalAPI.get(`/courses/${courseId}`)

const modules = async (courseId) =>
  trainingPortalAPI.get(`/courses/${courseId}/modules`)

const lesson = async (courseId, lessonId) =>
  trainingPortalAPI.get(`/courses/${courseId}/lessons/${lessonId}`)

const completeLesson = async (courseId, lessonId) =>
  trainingPortalAPI.post(`/courses/${courseId}/lessons/${lessonId}/complete`)

const exercise = async (courseId, lessonId) =>
  trainingPortalAPI.get(`/courses/${courseId}/lessons/${lessonId}/exercise`)

const exerciseAttempts = async (courseId, lessonId) =>
  trainingPortalAPI.get(
    `/courses/${courseId}/lessons/${lessonId}/exercise/attempts`,
  )

const submitExercise = async (courseId, lessonId, answers) =>
  trainingPortalAPI.post(
    `/courses/${courseId}/lessons/${lessonId}/exercise/attempts`,
    { answers },
  )

const certificate = async (courseId) =>
  trainingPortalAPI.get(`/courses/${courseId}/certificate`)

const inProgress = async (params = {}) =>
  trainingPortalAPI.get('/courses/in_progress', { params })

export default {
  categories,
  certificate,
  completeLesson,
  exercise,
  exerciseAttempts,
  index,
  indexByCategory,
  inProgress,
  lesson,
  modules,
  show,
  submitExercise,
}
